// ============================================================
// Permission guards (Brief v2 · Task 3 enforcement).
//
// The role flags (canEdit / canApprove / canCloseout) live on D.roles; these
// helpers turn them into action-level gates so read-only roles (client, and
// auditor/tdd on inspection data) genuinely cannot mutate, even if a control
// is reachable. Defense-in-depth alongside the route gating in grid.ts and the
// server-side RLS — a belt-and-braces "no edit access" for the client role.
// ============================================================
import { eng, activeRole } from "./engineApi";

export function canEdit(): boolean {
  return !!activeRole().canEdit;
}

export function canCloseout(): boolean {
  const r = activeRole();
  return !!(r.canEdit || r.canCloseout);
}

function deny(msg: string): false {
  try {
    eng().toast(msg, "warn");
  } catch {
    /* ignore */
  }
  return false;
}

/** Returns true if the active role may edit inspection data; else toasts + false. */
export function guardEdit(): boolean {
  return canEdit() || deny("Read-only role — editing is disabled");
}

/** Returns true if the active role may submit close-out / sign-off actions. */
export function guardCloseout(): boolean {
  return canCloseout() || deny("Your role can't take this action");
}
